import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { getCommentIdFromHash } from 'lib/comments';

const useCommentIdFromRouterHash = () => {
  const router = useRouter();
  const { asPath } = router;

  const commentId = useMemo(
    () => getCommentIdFromHash(asPath.split('#')[1]),
    [asPath]
  );

  return { commentId, isValidCommentIdHashAvailable: !!commentId };
};

export default useCommentIdFromRouterHash;
